/* eslint-disable react-hooks/exhaustive-deps */
import {
  useEffect,
  useState,
  useRef,
} from "react"
import { pageView } from "analytics"
import OrganizationNeedsSetupState from "./componentsOrganization/OrganizationNeedsSetupState"
import useCurrentUser from 'Hooks/useCurrentUser'
import useCurrentBrand from 'Hooks/useCurrentBrand'
import { useHistory } from "react-router-dom";
import useOrganization from 'Hooks/useOrganization'
import OrganizationTabs from "./OrganizationTabs"
import PageSymphony from "elements/PageSymphony"
import CardSymphony from "elements/CardSymphony"
import LoaderOverlay from "elements/LoaderOverlay"
import { OrganizationStatus } from "modules/Types"
import DebugBox from "components/shareable/DebugBox"

// loadedBrands represents ALL of the brands a user has access to
// teamArtists represents brands that are on the team
const OrganizationPage = () => {
  const history = useHistory()

  const {
    isSymphonyAdmin,
    isLoadingOrganizationFromAdminView
  } = useCurrentUser();

  const {
    isLoadingBrands,
    loadedBrands,
    loadedBrandsDict
  } = useCurrentBrand();

  const {
    organization,
    isLoadingOrganization,
    isLoadingSubscriptionView,
    isLoadingTeamMembers,
    organizationBrandIds,
    hasOrganizationAdminAccess
  } = useOrganization()

  // only show confetti if a user is on the screen, and just finished pro setup. 
  // dont show it any other times
  const [showConfetti, setShowConfetti] = useState(false)
  const [openCompletedModal, setOpenCompletedModal] = useState(false)
  const prevOrganizationStatus = useRef<OrganizationStatus>(OrganizationStatus.NOT_STARTED);

  useEffect(() => {
    pageView("Organization"); // NOTE: for analytics
    if (!hasOrganizationAdminAccess() && !isSymphonyAdmin) { // TODO CONNER: is this necessary?  if they are a member, they should be able to see the organization page
      history.push("/dashboard");
    }
  }, []);

  useEffect(() => {
    if (showConfetti) {
      setOpenCompletedModal(true)
    }
  }, [showConfetti])

  useEffect(() => {
    // Capture the status change specifically from PAID_BUT_NEEDS_SETUP to SETUP
    if (prevOrganizationStatus.current === OrganizationStatus.WAITING_FOR_DETAILS && organization?.status === OrganizationStatus.READY) {
      setShowConfetti(true);
    } else {
      setShowConfetti(false);
    }
    // Update the ref to the current status for the next render
    prevOrganizationStatus.current = organization?.status || OrganizationStatus.NOT_STARTED;
  }, [organization?.status]);

  // Renders the UI based on organization setup status
  const renderOrganizationPage = () => {
    switch (organization?.status) {
      case OrganizationStatus.WAITING_FOR_DETAILS:
        return (
          <CardSymphony
            className="organizationPageCard"
            style={{
              maxWidth: 750,
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <OrganizationNeedsSetupState />
          </CardSymphony>
        )
      case OrganizationStatus.READY:
        return <OrganizationTabs />
    }
  }

  const renderLoadingIndicator = () => {
    if (isLoadingOrganizationFromAdminView || isLoadingBrands || isLoadingOrganization || isLoadingSubscriptionView || isLoadingTeamMembers) {
      return (
        <LoaderOverlay
          className="organizationPageLoaderOverlay"
          title="Loading team details..."
          isTransparent
          isNavbar
        />
      )
    }
  }

  return (
    <PageSymphony
      className="organizationPageComponent"
      isContent
    >
      {renderLoadingIndicator()}
      {/* <DebugBox
        data={{
          organization,
          loadedBrands,
          loadedBrandsDict,
          organizationBrandIds,
          // isLoadingOrganization,
          // isLoadingBrands,
          // isLoadingOrganizationFromAdminView,
          // isLoadingSubscriptionView,
          // isLoadingTeamMembers,
        }}
        alwaysShow
        isApi
      /> */}
      {renderOrganizationPage()}
    </PageSymphony>
  )
}

export default OrganizationPage
